import React from 'react';
import styles from './TestimonialBlockV2.scss'
import Slider from "react-slick";

import PropTypes from "prop-types";

const TestimonialBlockV2 = props => {

	const slickRef = React.createRef();

	const getSlider = () => {
		const settings = {
			slidesToShow: props.slidesToShow,
			slidesToScroll: props.slidesToScroll,
			mobileFirst: props.mobileFirst,
			dots: props.dots,
			speed: props.speed,
			autoplaySpeed: props.autoplaySpeed,
			arrows: props.arrows,
			autoplay: props.autoplay,
			className: props.className,
			infinite: props.infinite,
			variableWidth: props.variableWidth,
			adaptiveHeight: props.adaptiveHeight,
			pauseOnHover: props.pauseOnHover,
			onInit: () => {
			}
		};

		return (
			<Slider {...settings} ref={slickRef}>
				{props.children}
			</Slider>
		)
	};

	return (
		<div id="js-client-reviews-container" className={styles.reviewContainerOuter}>
			{getSlider()}
		</div>
	);
};

const TestimonialBlockV2Body = ({children}) => {
	const classes = [];
	classes.push(styles.review);

	return (
		<div className={classes.join(' ')}>
			<div>
				<div className={styles.quote}>”</div>
				{children}
			</div>
		</div>
	);
}

const TestimonialBlockV2Author = ({children}) => {

	return (
		<div className={styles.author}>{children}</div>
	);
}

const TestimonialBlockV2Website = ({children}) => {
	if ((children !== undefined && children !== '')) {
		const website = children.replace('http://', '').replace('https://', '');

		return (
			<a href={`//${website}`} target="_blank" rel="noopener noreferrer">{website}</a>
		);
	} else {
		return "";
	}
}

TestimonialBlockV2.defaultProps = {
	slidesToShow: 1,
	slidesToScroll: 1,
	mobileFirst: false,
	dots: true,
	speed: 800,
	autoplaySpeed: 5000,
	arrows: false,
	autoplay: true,
	className: styles.slickSlider,
	infinite: true,
	variableWidth: false,
	adaptiveHeight: true,
	pauseOnHover: true
}

TestimonialBlockV2.propTypes = {
	slidesToShow: PropTypes.number,
	slidesToScroll: PropTypes.number,
	mobileFirst: PropTypes.bool,
	dots: PropTypes.bool,
	speed: PropTypes.number,
	autoplaySpeed: PropTypes.number,
	arrows: PropTypes.bool,
	autoplay: PropTypes.bool,
	className: PropTypes.string,
	infinite: PropTypes.bool,
	variableWidth: PropTypes.bool,
	adaptiveHeight: PropTypes.bool,
	pauseOnHover: PropTypes.bool,
	children: PropTypes.node
};

TestimonialBlockV2Body.propTypes = {
	children: PropTypes.node,
};

TestimonialBlockV2Author.propTypes = {
	children: PropTypes.node
};

TestimonialBlockV2Website.propTypes = {
	children: PropTypes.node
};

export default TestimonialBlockV2;
export {TestimonialBlockV2Body, TestimonialBlockV2Author, TestimonialBlockV2Website};
